import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {Link} from 'react-router-dom';
import {BusinessList} from 'components/fair/fair-business';

export default class FairBusiness extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Các doanh nghiệp tham gia hội chợ</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/businesses/reject`} className='dark'>Doanh nghiệp bị từ chối</Link>
              <Link to={`/fair/${this.props.match.params.id}/business/add`}>Thêm doanh nghiệp mới</Link>
            </div>
          </div>
          <BusinessList match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-business/FairBusiness.jsx